// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReactModal__Body--open {
  pointer-events: none;
}
.ReactModal__Body--open > .ReactModalPortal {
  pointer-events: all;
}

.swal2-container.swal2-center.swal2-backdrop-show {
  pointer-events: all;
}`, "",{"version":3,"sources":["webpack://./src/app.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;AACF;AACE;EACE,mBAAA;AACJ;;AAGA;EACE,mBAAA;AAAF","sourcesContent":[".ReactModal__Body--open {\n  pointer-events: none;\n\n  > .ReactModalPortal {\n    pointer-events: all;\n  }\n}\n\n.swal2-container.swal2-center.swal2-backdrop-show {\n  pointer-events: all;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
